var $pageEnd = 0;

$(document).ready(function () {
	jQuery('.js-whatsapp-open').on('click', function () {
		jQuery('.whatsapp-box').toggleClass('opened');
		return false;
	});
});

